/* HIT redesign: creator player (dialog), sticky mobile CTA, scroll reveal. No dependencies. */
(function () {
  'use strict';
  if (window.__hitxInit) return;
  window.__hitxInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function safePlay(v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }

  /* ---------- Creator player ---------- */
  function initPlayer(section) {
    var dlg = section.querySelector('.hitx-player');
    if (!dlg || dlg.dataset.init) return;
    dlg.dataset.init = '1';
    var video = dlg.querySelector('video');
    var handle = dlg.querySelector('.hitx-player__handle');
    var toggle = dlg.querySelector('.hitx-player__toggle');
    var mute = dlg.querySelector('.hitx-player__mute');
    var close = dlg.querySelector('.hitx-player__close');
    var lastFocus = null;

    function syncUi() {
      var playing = !video.paused;
      dlg.classList.toggle('is-paused', !playing);
      toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      dlg.classList.toggle('is-sound', !video.muted);
      mute.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
      mute.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    }
    function open(card) {
      lastFocus = document.activeElement;
      video.muted = true;
      video.poster = card.getAttribute('data-poster') || '';
      video.src = card.getAttribute('data-video');
      var credit = card.getAttribute('data-credit') || '';
      handle.textContent = credit;
      var link = card.getAttribute('data-link');
      if (link) { handle.href = link; handle.removeAttribute('aria-disabled'); handle.tabIndex = 0; }
      else { handle.removeAttribute('href'); handle.setAttribute('aria-disabled', 'true'); handle.tabIndex = -1; }
      dlg.setAttribute('aria-label', credit + ' video');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('hitx-lock');
      safePlay(video);
      syncUi();
      close.focus({ preventScroll: true });
    }
    function shut() {
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      try { video.load(); } catch (e) {}
      if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      document.documentElement.classList.remove('hitx-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    section.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.hitx-mq__card');
      if (card && section.contains(card)) open(card);
    });
    toggle.addEventListener('click', function () { if (video.paused) safePlay(video); else video.pause(); });
    mute.addEventListener('click', function () { video.muted = !video.muted; if (!video.muted) safePlay(video); syncUi(); });
    video.addEventListener('click', function () { if (video.paused) safePlay(video); else video.pause(); });
    video.addEventListener('play', syncUi);
    video.addEventListener('pause', syncUi);
    close.addEventListener('click', shut);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); shut(); });   /* Esc */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });  /* tap outside */
  }

  /* ---------- Sticky mobile CTA (after the hero) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-hitx-sticky]');
    var hero = document.querySelector('[data-hitx-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var link = bar.querySelector('a');
    new IntersectionObserver(function (entries) {
      var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      if (link) link.tabIndex = past ? 0 : -1;
    }, { threshold: 0 }).observe(hero);
  }

  /* ---------- Scroll reveal (once, ~400ms) ---------- */
  function initReveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = root.querySelectorAll('[data-hitx-reveal]:not(.hitx-pre)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    Array.prototype.forEach.call(els, function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return; /* already visible: leave it */
      el.classList.add('hitx-pre');
      io.observe(el);
    });
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-hitx-ugc]'), initPlayer);
    initReveal(root);
  }
  function fixNames() {
    Array.prototype.forEach.call(document.querySelectorAll('.sticky-add-to-cart__button'), function (b) {
      if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'Add to cart');
    });
  }
  function boot() { init(); initSticky(); fixNames(); window.addEventListener('load', fixNames); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
